/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : OrderFilter.tsx
*
* Project Title : Checkout
*
* Description   : Order History Filter Component
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Oct 26 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On            : Nov, 5 2020
* Description   : ASDS-4016 UI Enhancements for Phase-II
*
******************************************************************************/

import * as React from 'react';
import { DatePicker, Select } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import '@scuf/styles/variables.scss';
import HeaderBar from '@scuf/datatable/dist/components/DataTable/HeaderBar/HeaderBar';
import FilterPanel from '@scuf/datatable/dist/components/DataTable/HeaderBar/FilterPanel/FilterPanel';
import { connect } from 'react-redux';
import OrderHistoryActions from '../redux/actions/order-history-actions';

interface IOrderFilters {
    filters: {
        status: string,
        soldTo: string,
        fromDate: string,
        toDate: string
    };
    applyFilters: Function;
    soldTos: any;
    updateFilters: Function;
}

class OrderFilter extends React.Component <IOrderFilters, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: this.props.filters,
        };
    }

    handleStatusFilter(value: string) {
        this.setState(({ filters }) => {
            filters.status = value;
            this.props.applyFilters();
            return filters;
        });
    }

    handleSoldToFilter(value: string) {
        this.setState(({ filters }) => {
            filters.soldTo = value;
            this.props.applyFilters();
            return filters;
        });
    }

    countActiveFilters() {
        const { filters } = this.state;
        let count = 0;

        filters.status !== '' && count++;
        filters.soldTo !== '' && count++;
        filters.fromDate !== '' && filters.toDate !== '' && count++;

        this.props.updateFilters(filters, count);

        return count.toString();
    }

    render() {
        let soldToNumbers = [{
            text: this.state.filters.soldTo,
            value: this.state.filters.soldTo
        }];

        if (this.props.soldTos) {
            soldToNumbers = this.props.soldTos.map((soldTo) => {
                return {
                    value: soldTo,
                    text: soldTo
                };
            });
        }

        return (
            <HeaderBar.FilterPanel
                count={this.countActiveFilters()}
                onReset={() => this.onReset()}
            >
                <FilterPanel.Item>
                    <p className="field-section">Order Date Range</p>
                    <DatePicker
                        type="daterange"
                        disablePast={false}
                        disableFuture={true}
                        closeOnDocumentClick={true}
                        closeOnSelection={true}
                        rangeValue={{
                            to: this.state.filters.toDate && new Date(this.state.filters.toDate),
                            from: this.state.filters.fromDate && new Date(this.state.filters.fromDate)
                        }}
                        fluid={true}
                        className="filter-order-range"
                        onRangeSelect={({ to, from }) => {
                            this.setState(({ filters }) => {
                                if (to && from) {
                                    filters.toDate = typeof to === 'object' ? to.toDateString() : '';
                                    filters.fromDate = typeof from === 'object' ? from.toDateString() : '';
                                    this.props.applyFilters(this.state.filters);
                                    return filters;
                                }
                            });
                        }}
                    />
                </FilterPanel.Item>
                <FilterPanel.Item>
                    <p className="field-section">Order Status</p>
                    <FilterPanel.ToggleItem
                        type="checkbox"
                        label="In Progress"
                        className="filter-checkbox"
                        active={this.state.filters.status === 'InProgress'}
                        onChange={() => this.handleStatusFilter('InProgress')}
                    />
                    <FilterPanel.ToggleItem
                        type="checkbox"
                        label="Completed"
                        className="filter-checkbox"
                        active={this.state.filters.status === 'Completed'}
                        onChange={() => this.handleStatusFilter('Completed')}
                    />
                </FilterPanel.Item>
                <FilterPanel.Item>
                    <p className="field-section">Sold To No.</p>
                    <Select
                        placeholder="Type to search"
                        value={this.state.filters.soldTo}
                        search={true}
                        onChange={(value: any) => { this.handleSoldToFilter(value); }}
                        options={soldToNumbers}
                    />
                </FilterPanel.Item>
            </HeaderBar.FilterPanel>
        );
    }
    onReset(): void {
        this.setState(({ filters }) => {
            filters.soldTo = '';
            filters.status = '';
            filters.fromDate = '';
            filters.toDate = '';
            filters.reset = true;
            this.props.applyFilters(this.state.filters);
            this.props.updateFilters(this.state.filters, 0);
            return filters;
        });
    }
}

function mapStateToProps(state) {
    return {
        filters: state.orderHistoryData.filters
    };
 }

const mapDispatchToProps = {
    updateFilters: OrderHistoryActions.updateFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderFilter);
